<template>
    <transition name="slide">
        <div class="modal fade" tabindex="-1" role="dialog" :class="ondelete ? 'show' : 'show'" :style="ondelete ? 'display: block; padding-left: 0px;' : ''">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content shadow-3">
                    <div class="modal-header">
                        <div class="icon icon-shape rounded-3 bg-soft-danger text-danger text-lg me-4">
                            <i class="bi bi-trash3"></i>
                        </div>
                        <div>
                            <h5 class="mb-1">Eliminar registro</h5>
                            <small class="d-block text-xs text-muted">¿Realmente desea eliminar estos registros?<br> Este proceso no se puede deshacer.</small>
                        </div>
                        <div class="ms-auto">
                        </div>
                    </div>
                    <div class="modal-body">
                        <div class="d-flex align-items-center">
                            <div>
                                <p class="text-sm">Ingresa tu contraseña para permitir esta acción</p>
                            </div>
                        </div>
                        <div>
                            <v-text-field
                                v-model="password"
                                :append-icon="type ? 'mdi-eye' : 'mdi-eye-off'"
                                :type="type ? 'text' : 'password'"
                                class="form-control form-control-sm"
                                hide-details
                                @click:append="type = !type">
                            </v-text-field>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-h btn-danger px-3" @click="DELETE()">
                            <div class="spinner-border spinner-border-sm" role="status" v-if="count == 1">
                                <span class="sr-only">Loading...</span>
                            </div>
                            <span v-else>Eliminar</span>
                        </button>
                        <button type="button" class="btn btn-h btn-dark px-3" @click="$emit('onclose')">Cancelar</button>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>
<script>
export default{
    props: ['ondelete', 'id'],
    data(){
        return{
            password: '',
            type: false,
            count: 0
        }
    },
    methods: {
        DELETE: function(){
            let vue = this
            vue.count++
            if (vue.count == 1) {
                vue.errors = {}
                axios({ url: '/reasons/' + vue.id, method: 'DELETE', data: { password: vue.password } })
                    .then((resp) => {
                        vue.$swal({ toast: true, icon: 'success', title: 'Registro eliminado con éxito.', position: 'top-end', showConfirmButton: false, timer: 3000 })
                        vue.$emit('onreload')
                        vue.$emit('onclose')
                    })
                    .catch((err) => {
                        let message = err.response ? err.response.data.message : err.message
                        vue.$swal({ toast: true, icon: 'error', title: message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                    })
                    .finally((resp) => {
                        vue.count = 0
                    })
            }
        }
    }
}
</script>